export default __webpack_public_path__ + "static/media/lubelskie.cc5fc112.png";